import { useEffect, useState } from 'react';
import OrderApi from '../../Api/OrderApi';
import { Order } from '../../Models/Order';
import Loader from '../Common/Loader';
import { Button } from 'flowbite-react';
import { useAppSelector } from '../../Reducers/store';
import { Link } from 'react-router-dom';

export default function OrderConfirmation() {
  const { userModel } = useAppSelector((state) => state.user);
  const [loading, setIsLoading] = useState<boolean>();

  const checkUpdateOpenOrder = async () => {
    if (userModel) {
      let openOrderId = 0;
      await OrderApi.checkUserOpenOrder(userModel.id)
        .then((res) => {
          if (res.data) {
            openOrderId = res.data.id;
            localStorage.setItem('openOrderId', openOrderId.toString());
          } else {
            const newOrder: Order = {
              id: 0,
              businessName: null,
              contactName: null,
              contactPhone: null,
              contactEmail: null,
              notes: null,
              dateCreated: null,
              orderStatusId: 1,
              userId: userModel.id,
              billingAddressId: null,
              shippingAddressId: null,
              dateSubmitted: null,
              ponumber: null,
              clientId: userModel.clientId,
              shippingMethodId: 15,

              client: null,
              orderItems: [],
              billingAddress: null,
              shippingAddress: null,
              user: null,
            };
            OrderApi.addUpdateOrder(newOrder)
              .then((res) => {
                if (res.data.success) {
                  openOrderId = Number(res.data.affectedEntityIdentifier);
                  localStorage.setItem('openOrderId', openOrderId.toString());
                }
              })
              .catch((err) => {
                setIsLoading(false);
              });
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
      await OrderApi.getOrderItemsCount(openOrderId)
        .then((res) => {
          if (res.data !== null) {
            localStorage.setItem('orderItemsCount', res.data.toString());
            window.dispatchEvent(new Event('updateOrderItemCount'));
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    checkUpdateOpenOrder();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className='w-full mt-4'>
        <div className='container mx-auto p-2 h-[calc(100vh-80px)] lg:h-[calc(100vh-142px)] overflow-y-auto'>
          <div className='mb-2 flex justify-between'>
            <h1 className='text-gray-900 font-bold text-2xl md:text-4xl'>
              Order Confirmation:
            </h1>
          </div>
          <hr className='my-5'></hr>
          <div className='w-full mb-2 flex justify-between'>
            <div className='flex flex-col px-0 text-md lg:px-5 md:text-lg lg:text-xl items-center w-full'>
              <div className='font-bold content-center mb-5'>
                Thank you for submitting your order
              </div>
              <div className='font-bold content-center'>
                For additional questions:
              </div>
              <div className='font-bold content-center'>(316) 265-9577</div>
              <div className='font-bold content-center'>
                parts@pricebroseq.com
              </div>
              <div className='flex gap-2 mt-5'>
                <div>
                  <Link to={`/`}>
                    <Button className='buttonMain'>Return Home</Button>
                  </Link>
                </div>
                <div>
                  <Link to={`/orders/list`}>
                    <Button className='buttonMain'>View Orders</Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
